import script from "./Watermark.vue?vue&type=script&setup=true&lang=js"
export * from "./Watermark.vue?vue&type=script&setup=true&lang=js"

import "./Watermark.vue?vue&type=style&index=0&id=b313748c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b313748c"]])

export default __exports__